import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 200px;
  overflow: auto;
  margin: 24px 0;
`;

export const Year = styled.button<{ selected: boolean }>`
  transition: background-color 0.3s ease;
  appearance: none;
  background-color: rgba(0, 0, 0, 0);
  border: none;
  outline: none;
  margin: 4px 0;
  padding: 4px 0;
  height: 28px;
  font-size: 16px;

  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.2);
      }
    `}

  ${({ selected, theme }) =>
    selected &&
    css`
      color: ${theme.colors.white};
      background-color: ${theme.colors.lightBlue};

      &:hover {
        cursor: pointer;
        background-color: ${theme.colors.lightBlue};
      }
    `}
`;
